export interface FlowResponse {
  flow: Flow | null;
  flowAccessToken: string;
}

export interface Flow {
  typeCode: FlowTypeCode;
  passedSteps: FlowStep[];
  activeStep: FlowStep | null;
}

export interface FlowStep {
  typeCode: FlowTypeCode;
  link?: string;
  passed?: boolean;
  optional?: boolean;
  shouldGenerateQrCode?: boolean;
  allowResendInSeconds?: number;
  otpLength?: number;
  otpTokenExpiredInSeconds?: number;
}

export enum FlowTypeCode {
  ADMIN_AUTH_METHOD_CHOICE = "admin_auth_method_choice",
  ADMIN_GOOGLE_TWO_FACTOR_AUTHENTICATION = "admin_google_2fa",
  ADMIN_AUTH = "admin_auth",
  OTP = "otp",
}

export enum AuthenticationMethodType {
  GOOGLE_AUTHENTICATOR = 1,
  EMAIL_NOTIFICATION = 2,
}

export interface AuthenticationMethodStep {
  label: string;
  description: string;
  value: AuthenticationMethodType;
}

export interface QrCodeResponse {
  textCode: string;
  qrCode: string;
}

export interface VerifyOtpRequest {
  /**
   * Otp token provided by send otp action
   */
  otp_token?: string;
  otp_value: string;
}
